<div class="flex flex-col gap-4 w-full pt-2">
  <h6 *ngIf="state !== 'both'"
    class="text-exp text-xs text-center font-medium uppercase tracking-wider">
    {{ (state === 'now' ? 'txt_cvf_pass_now' : 'txt_cvf_pass_future')
       | translate:language:ModuleNames.Culture }}
  </h6>
  <!-- Instruction / Header Row (md: and up only -- mobile shows the Now/Preferred labels inline per row instead) -->
  <div class="hidden md:flex flex-row items-center border-b border-zen border-opacity-10 pb-2 px-2">
    <div [ngClass]="statementWidthClass" class="font-medium text-xs text-zen text-opacity-60 uppercase tracking-wider">
      {{'txtStatement'|translate:language:ModuleNames.Culture}}</div>
    <div *ngIf="showNow"
      class="w-2/12 font-medium text-xs text-zen text-opacity-60 text-center uppercase tracking-wider">
      {{'txt_Now'|translate:language:ModuleNames.Culture}}</div>
    <div *ngIf="showFuture"
      class="w-2/12 font-medium text-xs text-zen text-opacity-60 text-center uppercase tracking-wider">
      {{'txt_Preferred'|translate:language:ModuleNames.Culture}}</div>
  </div>

  <!-- Answering Matrix Rows -->
  <div *ngFor="let option of question.questionOptions; let i = index"
       class="flex flex-col md:flex-row items-stretch md:items-center bg-white rounded-lg p-4 border border-zen border-opacity-5 gap-3 md:gap-2 my-1">
    <div [ngClass]="statementWidthClass" class="flex flex-row items-start gap-3 w-full">
      <div class="flex-shrink-0 w-6 h-6 rounded-full bg-exp bg-opacity-10 text-exp flex items-center justify-center font-bold text-xs">
        {{['A', 'B', 'C', 'D'][i]}}
      </div>
      <h5 class="text-zen text-sm leading-relaxed whitespace-normal pr-2 cvf-statement-text">
        {{extractNameLanguage(option.name)}}
      </h5>
    </div>

    <!-- NOW Allocation Input -->
    <div *ngIf="showNow" class="flex flex-row md:w-2/12 items-center justify-between md:justify-center gap-1">
      <span class="md:hidden font-medium text-xs text-zen text-opacity-60 uppercase tracking-wider">
        {{'txt_Now'|translate:language:ModuleNames.Culture}}</span>
      <div class="flex flex-row items-center gap-1"
           (wheel)="onClusterWheel($event, 'now', option.key)">
        <a zenButton styles="ghost icon-11" class="md:h-8 md:w-8 md:leading-8 text-sm md:text-xs font-medium"
           [ngClass]="isAtMin('now', option.key) ? 'opacity-30 pointer-events-none' : ''"
           (click)="adjustValue('now', option.key, -cvfStep)">-{{cvfStep}}</a>
        <input type="number" min="0" max="100" #nowInput
               class="w-14 h-11 md:w-16 md:h-10 border rounded-md text-center font-semibold md:font-medium text-lg md:text-base text-zen focus:outline-none focus:border-exp"
               [ngModel]="valueOf('now', option.key)"
               (keydown)="blockInvalidKeys($event)"
               (ngModelChange)="onInputChange('now', option.key, $event, nowInput)" />
        <a zenButton styles="ghost icon-11" class="md:h-8 md:w-8 md:leading-8 text-sm md:text-xs font-medium"
           [ngClass]="isAtMax('now') ? 'opacity-30 pointer-events-none' : ''"
           (click)="adjustValue('now', option.key, cvfStep)">+{{cvfStep}}</a>
      </div>
    </div>

    <!-- FUTURE Allocation Input -->
    <div *ngIf="showFuture" class="flex flex-row md:w-2/12 items-center justify-between md:justify-center gap-1">
      <span class="md:hidden font-medium text-xs text-zen text-opacity-60 uppercase tracking-wider">
        {{'txt_Preferred'|translate:language:ModuleNames.Culture}}</span>
      <div class="flex flex-row items-center gap-1"
           (wheel)="onClusterWheel($event, 'future', option.key)">
        <a zenButton styles="ghost icon-11" class="md:h-8 md:w-8 md:leading-8 text-sm md:text-xs font-medium"
           [ngClass]="isAtMin('future', option.key) ? 'opacity-30 pointer-events-none' : ''"
           (click)="adjustValue('future', option.key, -cvfStep)">-{{cvfStep}}</a>
        <input type="number" min="0" max="100" #futureInput
               class="w-14 h-11 md:w-16 md:h-10 border rounded-md text-center font-semibold md:font-medium text-lg md:text-base text-zen focus:outline-none focus:border-exp"
               [ngModel]="valueOf('future', option.key)"
               (keydown)="blockInvalidKeys($event)"
               (ngModelChange)="onInputChange('future', option.key, $event, futureInput)" />
        <a zenButton styles="ghost icon-11" class="md:h-8 md:w-8 md:leading-8 text-sm md:text-xs font-medium"
           [ngClass]="isAtMax('future') ? 'opacity-30 pointer-events-none' : ''"
           (click)="adjustValue('future', option.key, cvfStep)">+{{cvfStep}}</a>
      </div>
    </div>
  </div>

  <!-- Real-time Summation & Validation Footer. Pins to the bottom of the screen until the page is scrolled to it. -->
  <div #totalsSlot class="mt-2" [style.minHeight.px]="totalsHeight">
    <div class="flex flex-row items-center p-3 z-10"
      [ngClass]="floating
        ? 'fixed inset-x-0 px-7 md:px-20 bg-white border-t border-zen border-opacity-10 shadow-md'
        : 'rounded-lg bg-zen bg-opacity-5 border border-zen border-opacity-10'"
      [style.bottom.px]="floating ? navOffset : null">
      <div [ngClass]="statementWidthClass" class="flex flex-col flex-1 min-w-0 md:flex-none">
        <span class="font-bold text-xs text-zen uppercase tracking-wide">
          {{'txt_cvf_total_allocated'|translate:language:ModuleNames.Culture}}</span>
        <span class="text-xxs text-zen text-opacity-60">
          {{'txt_cvf_must_total_100'|translate:language:ModuleNames.Culture}}</span>
      </div>

      <!-- NOW Total Display -->
      <div *ngIf="showNow" class="md:w-2/12 shrink-0 px-2 flex flex-col items-center justify-center text-center">
        <span class="font-bold text-lg leading-tight"
              [ngClass]="nowTotal === cvfTotal ? 'text-zen-green' : 'text-zen-red'">
          {{nowTotal}}
        </span>
        <span class="text-xxs font-medium mt-0.5 whitespace-nowrap"
              [ngClass]="nowTotal === cvfTotal ? 'text-zen-green' : 'text-zen-red'">
          {{(nowTotal === cvfTotal ? 'txt_cvf_valid' : 'txt_cvf_invalid')|translate:language:ModuleNames.Culture}}
        </span>
      </div>

      <!-- FUTURE Total Display -->
      <div *ngIf="showFuture" class="md:w-2/12 shrink-0 px-2 flex flex-col items-center justify-center text-center">
        <span class="font-bold text-lg leading-tight"
              [ngClass]="futureTotal === cvfTotal ? 'text-zen-green' : 'text-zen-red'">
          {{futureTotal}}
        </span>
        <span class="text-xxs font-medium mt-0.5 whitespace-nowrap"
              [ngClass]="futureTotal === cvfTotal ? 'text-zen-green' : 'text-zen-red'">
          {{(futureTotal === cvfTotal ? 'txt_cvf_valid' : 'txt_cvf_invalid')|translate:language:ModuleNames.Culture}}
        </span>
      </div>
    </div>
  </div>
</div>
